module.exports = "/static/assets/63b8962ea3c519d3b4fa7fb00a166f50.png";